/**
 * Steps in the reservation flow process
 * @type {Object}
 * @property {number} SELECT_LOCATION - Step to select location
 * @property {number} SELECT_DATES - Step to select dates
 * @property {number} SELECT_ROOMS - Step to select rooms
 * @property {number} CONFIRMATION - Step to confirm reservation
 */
export const STEPS = Object.freeze({
    SELECT_LOCATION: 0,
    SELECT_DATES: 1,
    SELECT_ROOMS: 2,
    CONFIRMATION: 3,
});

/**
 * Steps in the reservation flow process.
 * @type {string[]}
 */
export const steps = ['selectLocation', 'selectDatesAndGuests', 'selectRooms', 'confirmation'];


/**
 * Returns tomorrow's date in ISO format
 * @returns {string}
 */
export const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split('T')[0];
}
